import React from "react"
import { useTheme } from "~/ui/styled"
import { ColumnFlex, StartFlex, Text } from "~components/El"
import { UploadableAvatar } from "~widgets/avatar"

const AvatarUpload = ({ onChange, image = "" }) => {
    const theme = useTheme()
    return (
        <ColumnFlex width="100%">
            <Text fontSize={16} color={theme.colors.text} fontWeight={600} padding="12px 0 8px 0">群聊信息</Text>
            <StartFlex width="100%">
                <UploadableAvatar
                    size={48}
                    avatar={image}
                    icon="cjql"
                    color={theme.colors.secondary}
                    backgroundColor={theme.colors.border}
                    onChange={onChange}
                />
                <ColumnFlex ml="16px">
                    <Text fontSize={14} color={theme.colors.text} fontWeight={600}>群头像</Text>
                    <Text fontSize={12} color={theme.colors.secondaryText}>点击上传自定义头像，不选择将使用系统默认头像</Text>
                </ColumnFlex>
            </StartFlex>
        </ColumnFlex>
    )
}

export default React.memo(AvatarUpload)
